<template>
  <LayoutMinimal>
    <section id="payment_result">
      <div class="content">
        <div class="title">
          <h3>
            <template v-if="loading || error">
              {{ $t("payment_result.title") }}
            </template>
            <template v-else>
              <template>
                {{ $t("payment_result.title") }}
              </template>
            </template>
          </h3>
        </div>

        <template v-if="loading || error">
          <div class="loading-or-error">
            <Spinner v-if="loading" />
            <p v-if="error">
              {{ $t("error") }}
            </p>
          </div>
        </template>

        <div class="buttons">
          <template v-if="$auth.ready() && $auth.user().membership_active">
            <router-link class="btn main-btn" :to="{ name: 'home' }">
              {{ $t("back_to_home") }}
            </router-link>
          </template>
          <template v-else>
            <router-link class="btn main-btn" :to="{ name: 'dashboard' }">
              {{ $t("header.dashboard") }}
            </router-link>
          </template>
        </div>
      </div>
    </section>
    <template slot="after">
      <Footer />
    </template>
  </LayoutMinimal>
</template>

<script>
import Spinner from "../../components/Spinner";
import Footer from "../../components/Footer";
import LayoutMinimal from "../../layouts/LayoutMinimal";

export default {
  components: {
    Spinner,
    LayoutMinimal,
    Footer,
  },
  data() {
    return {
      loading: true,
      error: false,
    };
  },
  computed: {},
  methods: {},
  watch: {},
  beforeRouteUpdate(to, from, next) {},
  mounted() {
    const redirect_data = this.$route.query.redirect_data;
    redirect_data
      ? (window.location.href = redirect_data)
      : this.$router.push({ name: "home" });
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";

#payment_result {
  .title {
    text-align: center;

    & > * {
      display: inline-block;
      background-color: var(--pallete_main_color);
      color: #ffffff;
      font-weight: bolder;
      text-transform: uppercase;
      font-size: 1.5em;
      margin: 0;
      margin-bottom: 1em;
      padding: 0.25em;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    }
  }

  .buttons {
    display: block;
    height: auto;
    margin-top: 3em;
    text-align: center;

    .btn.main-btn {
      @extend %fresh-btn;
      padding: 0.5em;
    }
  }
}
</style>
